import './index.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import { showToast } from '../../../actions/app-actions-types';
import { generateReferralLink } from '../../../actions/user-actions-types';
import { Header, ScreenBackground, View, Text, ShareModal, RouteWrapper } from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import Constants from '../../../constants';
import Button from '@mui/material/Button/Button';
declare const window: any;
const Referral = () => {
  const navigate = useLink();
  const dispatch = useDispatch();
  const { MoreTheme: theme } = useTheme();
  const [shareLinkModal, setShareLinkModal] = useState(false);

  const user = useSelector((state: any) => state.user);
  const { referralLink = '' } = user;
  const message = `Get ₹100 bonus to play on iGamio and also Earn Unlimited Real Cash with referred Friends. Download the app by using my link ${referralLink}`;

  useEffect(() => {
    window.addEventListener('popstate', onClickBrowserBack);
    return () => {
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setShareLinkModal(false);
  };

  const onPressGenerateLink = async () => {
    dispatch(
      generateReferralLink({
        callback: ({ error }: { error: any }) => {
          if (!error) {
            dispatch(showToast(I18n.t('ReferralLinkGeneratedMessage')));
            EventEmitter.emit('UserInfo');
          }
        }
      })
    );
  };

  const onPressCode = async () => {
    if (!window?.ReactNativeWebView) {
      await navigator.clipboard.writeText(referralLink);
    }
    dispatch(showToast(I18n.t('referralLinkCopied')));
  };

  const onPressShareLink = async () => {
    if (!window?.ReactNativeWebView) {
      setShareLinkModal(true);
    }
  };

  const contentWrapper = {
    backgroundColor: theme.referEarnContentBG
  };

  const referCodeLabel = {
    color: theme.referEarnLabel
  };

  const referralCodeWrapper = {
    borderColor: theme.referEarnCodeBorder
  };

  const referEarnCode = {
    color: theme.referEarnCode
  };

  const tapToCopy = {
    color: theme.referEarnTapToCopy
  };

  const referGain = {
    color: theme.referEarnMessage
  };

  const shareBtn = {
    backgroundColor: theme.referEarnShareBtn,
    color: theme.referEarnShareBtnTitle
  };

  const isReferralLinkExist = referralLink != null && referralLink.length > 0;

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onPressDismiss = () => {
    setShareLinkModal(false);
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header onClickBack={onClickBack} title={'Refer And Earn'} />
        <View className={'referral-image'}>
          <Constants.Svgs.ReferImage width={'300px'} height={'300px'} />
        </View>
        <View className={'referral-content-wrapper'} style={contentWrapper}>
          <Text className={'referral-code-label'} style={referCodeLabel}>
            {I18n.t('ReferralLinkLabel')}
          </Text>
          {isReferralLinkExist && (
            <View className={'referral-code-wrapper'} style={referralCodeWrapper}>
              <Text className={'referral-code'} style={referEarnCode}>
                {referralLink}
              </Text>
              <View className={'referral-tap-to-copy-wrapper'} onPress={onPressCode}>
                <Text className={'referral-tap-to-copy'} style={tapToCopy}>
                  {I18n.t('TapToCopyCode')}
                </Text>
              </View>
            </View>
          )}
          <Text className={'referral-gain'} style={referGain}>
            {I18n.t('ReferGain')}
          </Text>
          <Button
            className={'referral-button'}
            onClick={isReferralLinkExist ? onPressShareLink : onPressGenerateLink}
            style={shareBtn}>
            {isReferralLinkExist ? I18n.t('ShareLink') : I18n.t('GenerateLink')}
          </Button>
        </View>
        <ShareModal
          title={'Checkout this cool app!'}
          message={message}
          link={referralLink}
          visible={shareLinkModal}
          onPressDismiss={onPressDismiss}
        />
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default Referral;
